export const highPriorityIconTooltip = "_iuXHd";
export const lowPriorityIconTooltip = "UgwKKc";
export const highPriorityLabel = "wKVD$b";
export const lowPriorityLabel = "_m66N";
export default {highPriorityIconTooltip,lowPriorityIconTooltip,highPriorityLabel,lowPriorityLabel};